// extracted by mini-css-extract-plugin
export var social = "social-media-links-list-module--social--0a45d";